import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const SchoolCabinet = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Student Cabinets" midBreadcrumb="Office Bearers" mainBreadcrumb="Student Cabinets" ></Breadcrumb>
            <div className='inner-page'>
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="mainhead mainhead-center">Student Cabinets</h2>
                            <h3 class="subhead text-center">If your actions inspire others to dream more, learn more, do more and become
                                more, you are a leader</h3>
                        </div>
                    </div>
                    <div class="row sc">
                        <div class="col-lg-6">
                            <h2>Head Boy & Head Girl</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/1.HEAD BOY BHAVYA (XII LILY).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">HEAD BOY</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">BHAVYA (XII LILY) </div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/2. HEAD GIRL CRYSTAL XII(SCI).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Head Girl</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">CRYSTAL XII(SCI)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2>Ass.Head Boy & Ass.Head Girl</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/3. ASST. HEAD BOY KOVID MEHTA XI(SCI).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Ass. Head Boy</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">KOVID MEHTA XI(SCI)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/4. ASST HEAD GIRL ANSHU DAHIYA XI(COMM).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation"> Ass. Head Girl</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name"> ANSHU DAHIYA XI(COMM)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2>Cultural Minister</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/5. CULTURAL & SOCIAL WELFARE MINISTER ARNA IX(ROSE).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Cultural  & SOCIAL WELFARE Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">ARNA IX(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/6. CULTURAL & SOCIAL WELFARE MINISTER NIMISH IX(LILY).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Cultural  & SOCIAL WELFARE Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name"> NIMISH IX(LILY)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2>Sports Minister</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/13. SPORTS MINISTER ANSHIKA X(LILY).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Sports Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name"> ANSHIKA X(LILY)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/14. SPORTS MINISTER NAKUL IX(ROSE).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Sports Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">NAKUL IX(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                        <h2>Home Minister </h2>
                        <div class="row g-3">
                            <div class="col-sm-6 col-6">
                                <div class="student-cabinets">
                                    <figure>
                                        <div class="cabinet-img">
                                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/11. HOME MINISTER MITALI X(ROSE).JPG" class="img-fluid "
                                                alt="matamariamjansevavidyalayas" />
                                            <div class="cabinet-detail">
                                                <div class="cabinet-designation">Home Minister </div>
                                            </div>
                                        </div>
                                        <figcaption class="text-center">
                                            <div class="cabinet-name">MITALI X(ROSE)</div>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                            <div class="col-sm-6 col-6">
                                <div class="student-cabinets">
                                    <figure>
                                        <div class="cabinet-img">
                                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/12.HOME MINISTER MANAN IX(ROSE).JPG" class="img-fluid "
                                                alt="matamariamjansevavidyalayas" />
                                            <div class="cabinet-detail">
                                                <div class="cabinet-designation">Home Minister </div>
                                            </div>
                                        </div>
                                        <figcaption class="text-center">
                                            <div class="cabinet-name">MANAN IX(ROSE)</div>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                    <h2>  EXternal Affairs  Minister</h2>
                    <div class="row g-3">
                        <div class="col-sm-6 col-6">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/9. EXTERNAL AFFAIRS  MINISTER DHRUV X(LILY).JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">EXternal Affairs  Minister</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">DHRUV X(LILY)</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <div class="col-sm-6 col-6">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/10. EXTERNAL AFFAIRS  MINISTER HEMANGI IX(LILY).JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">EXternal Affairs  Minister</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">HEMANGI IX(LILY)</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
                        <div class="col-lg-6">
                            <h2>     Student Interest Group Minister  </h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/7. STUDENT INTEREST GROUP MINISTER DEV X(ROSR).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">  Student Interest Group Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name"> DEV X(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/8. STUDENT INTEREST GROUP MINISTER SANCHI X(LILY).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">  Student Interest Group Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">SANCHI X(LILY)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2>Language Minister</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/7. ENGLISH EDITOR SAKSHI XII (SCI.jpg" class="img-fluid"
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Language Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">SAKSHI XII (SCI)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/8. HINDI EDITOR MISHIKA IX(ROSE).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Language Minister</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">MISHIKA IX(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
              { /*      <div class="row g-3 cabinet5">
                        <div class="col-12 sc">
                            <h2>Swachhta Ministers</h2>
                        </div>
                        <div class="col">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/swm1.JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">Swachhta Ministers</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">Master. Rahul Sain</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <div class="col">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/swm2.JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">Swachhta Ministers</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">Master. Yaman</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <div class="col">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/swm3.JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">Swachhta Ministers</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">Miss. Kalpana</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <div class="col">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/swm4.JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">Swachhta Ministers</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">Miss. Vanshika</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <div class="col">
                            <div class="student-cabinets">
                                <figure>
                                    <div class="cabinet-img">
                                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/swm5.JPG" class="img-fluid "
                                            alt="matamariamjansevavidyalayas" />
                                        <div class="cabinet-detail">
                                            <div class="cabinet-designation">Swachhta Ministers</div>
                                        </div>
                                    </div>
                                    <figcaption class="text-center">
                                        <div class="cabinet-name">Miss. Vandana</div>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
    </div> */}
                    <div class="row sc">
                        <div class="col-lg-6">
                            <h2 class="bg-red">Red House</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/1. RED HOUSE CAPTAIN JANVI XI (COMM).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Red House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">JANVI XI (COMM)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/2. RED HOUSE VICE-CAPTAIN TANMAY IX(ROSE).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Red House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">TANMAY IX(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2 class="bg-blu">Blue House</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/5. BLUE HOUSE CAPTAIN  CHAHAK VERMA XI(SCI).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Blue House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">CHAHAK VERMA XI(SCI)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/6. BLUE HOUSE VICE CAPTAIN JAY IX(ROSE).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation"> Blue House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">JAY IX(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2 class="bg-yellow">Yellow House</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/3. YELLOW HOUSE CAPTAIN ARYAN XI(SCI).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Yellow House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">ARYAN XI(SCI)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/4. YELLOW HOUSE VICE CAPTAIN DEEPLAKSHMI IX(ROSE).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Yellow House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">DEEPLAKSHMI IX(ROSE)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <h2 class="bg-green">Green House</h2>
                            <div class="row g-3">
                                <div class="col-sm-6 col-6">
                                    <div class="student-cabinets">
                                        <figure>
                                            <div class="cabinet-img">
                                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/7. GREEN HOUSE CAPTAIN MAAHI XI(SCI).JPG" class="img-fluid "
                                                    alt="matamariamjansevavidyalayas" />
                                                <div class="cabinet-detail">
                                                    <div class="cabinet-designation">Green House</div>
                                                </div>
                                            </div>
                                            <figcaption class="text-center">
                                                <div class="cabinet-name">MAAHI XI(SCI)</div>
                                            </figcaption>
                                        </figure>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-6">
                                <div class="student-cabinets">
                                    <figure>
                                        <div class="cabinet-img">
                                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/8. GREEN HOUSE VICE CAPTAIN PRIYANSHU IX (LILY).JPG" class="img-fluid "
                                                alt="matamariamjansevavidyalayas" />
                                            <div class="cabinet-detail">
                                                <div class="cabinet-designation">Green House</div>
                                            </div>
                                        </div>
                                        <figcaption class="text-center">
                                            <div class="cabinet-name">PRIYANSHU IX (LILY)</div>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default SchoolCabinet